export default [{
    path: '/zkteco',
    name: 'zkteco',
    meta: {
      layout: 'main'
    },
    component: () => import('@/views/zkteco/index')
  }]
  